"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM = exports.SHOULD_BE_CLOSED_COOKIE = void 0;
var SHOULD_BE_CLOSED_COOKIE = exports.SHOULD_BE_CLOSED_COOKIE = 'outdatedBrowserClosed';
var TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM = exports.TEST_OUTDATED_BROWSER_INFO_QUERY_PARAM = 'testOutdatedBrowserInfo'; //# sourceMappingURL=app.js.map
